module.exports = __webpack_public_path__ + "static/img/7.67ad90d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/7.png
// module id = 1d7s
// module chunks = 0